// Import node modules
import $ from 'jquery';

// Import polyfills
require('./modules/polyfill.js');

// Import vendor scripts
require('./vendor/vendor.js');
require('./vendor/bootstrap');

// Import custom modules
import {
  isDesktop,
  disableScroll,
  isTouchScreen,
  CLASS_TOUCH_SCREEN
} from './modules/helpers';
import branchBar from './modules/branch-bar';
import header from './modules/header';
import yearScroller from './modules/year-scroller';
import timeline from './modules/timeline';
import share from './modules/share';
import followUs from './modules/follow-us';
import Preloader from './modules/preloader';
import customCursors from './modules/custom-cursors';
import {scrollToTop} from './modules/helpers';
import notifications from './modules/notifications';
import decades from './modules/decades';

//Initialize everything on document ready
$(document).ready(() => {

  // If touch screen add class to the body
  if (isTouchScreen()) {
    document.body.classList.add(CLASS_TOUCH_SCREEN);
  }

  // Set cursors for buttons and anchor tags.
  customCursors.setElementCursorTypes({
    point: ['a','button:not(.year-button)'],
  });

  let preloader;

  const preloaderElement = document.querySelector('[data-preloader]');

  // If year scroller found
  if (yearScroller.exists()) {

    // Desktop: Use preloader and after it is finished start year scroller entrance animations
    if (isDesktop()) {
      disableScroll();
      const yearScrollerStartFunction = yearScroller.start.bind(yearScroller);

      preloaderElement.addEventListener('preloader.completed', yearScrollerStartFunction);
      preloaderElement.addEventListener('preloader.beforeCompletion', scrollToTop);

      preloader = new Preloader(preloaderElement);
      preloader.start();

    // If mobile just remove preloader
    } else {
      if (preloaderElement !== null) {
        preloaderElement.remove();
      }
    }

    // Initialize year scroller
    yearScroller.init();

  } else {

    // If there are preloader elements remove them
    if (preloaderElement !== null) {
      preloaderElement.remove();
    }
  }

  branchBar.init();
  header.init();
  timeline.init();
  share.init();
  followUs.init();
  decades.init();

  // Initialize cookie and legacy browser notification (./modules/notifications.js)
  if (preloader) {
    preloaderElement.addEventListener('preloader.completed', () => {
      notifications.init();
    });
  } else {
    notifications.init();
  }

  // If year scroller found
  if (yearScroller.exists()) {
    if (isDesktop()) {
      // Complete preloader
      preloader.complete();
    } else {
      // Start year scroller
      yearScroller.start();
    }
  }
});